import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PhoneNumberRoamingStatus } from '../../../../utils/const';

const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => (
  bindActionCreators({

  }, dispatch)
)

class SearchResultEmailByPhone extends Component {
  render() {
    const { data } = this.props
    const { country_code, country_name, country_prefix, request_price, remaining_balance,  
      international_format_number, national_format_number, valid_number, reachable, ported, ip_warnings,
      roaming, current_carrier, original_carrier,
    } = data
    
    return (
      <div className="email-container">
        <h3>Phone Information</h3>
        <table><tbody>
          <tr>
            <td>International Number :</td>
            <td>{international_format_number}</td>
          </tr>
          <tr>
            <td>National Number :</td>
            <td>{national_format_number}</td>
          </tr>
          <tr>
            <td>Country Name :</td>
            <td>{country_name}</td>
          </tr>
          <tr>
            <td>Country Prefix :</td>
            <td>{country_prefix}</td>
          </tr>
          <tr>
            <td>Valid :</td>
            <td>{valid_number}</td>
          </tr>
          <tr>
            <td>Request Price :</td>
            <td>{request_price}</td>
          </tr>
          <tr>
            <td>Remaining Balance :</td>
            <td>{remaining_balance}</td>
          </tr>
          <tr>
            <td>Reachable :</td>
            <td>{reachable}</td>
          </tr>
          <tr>
            <td>Ported :</td>
            <td>{ported}</td>
          </tr>
          <tr>
            <td>IP Warnings :</td>
            <td>{ip_warnings}</td>
          </tr>
          <tr>
            <td>Roaming :</td>
            <td>
              {roaming.status}
              { PhoneNumberRoamingStatus.ROAMING === roaming.status ?
                <div className="pl-3">
                  <p>Country Code : {roaming.roaming_country_code}</p>
                  <p>Network Code : {roaming.roaming_network_code}</p>
                  <p>Network Name : {roaming.roaming_network_name}</p>
                </div>
                :
                <div/>
              }
            </td>
          </tr>
        </tbody></table>
        { current_carrier ?
          <div>
            <h3>Current Carrier</h3>
            <table><tbody>
              <tr>
                <td>Name :</td>
                <td>{current_carrier.name}</td>
              </tr>
              <tr>
                <td>Country :</td>
                <td>{current_carrier.country}</td>
              </tr>
              <tr>
                <td>Network Code :</td>
                <td>{current_carrier.network_code}</td>
              </tr>
              <tr>
                <td>Network Type :</td>
                <td>{current_carrier.network_type}</td>
              </tr>
            </tbody></table>
          </div>
          :
          <div/>
        }
        { original_carrier ?
          <div>
            <h3>Current Carrier</h3>
            <table><tbody>
              <tr>
                <td>Name :</td>
                <td>{original_carrier.name}</td>
              </tr>
              <tr>
                <td>Country :</td>
                <td>{original_carrier.country}</td>
              </tr>
              <tr>
                <td>Network Code :</td>
                <td>{original_carrier.network_code}</td>
              </tr>
              <tr>
                <td>Network Type :</td>
                <td>{original_carrier.network_type}</td>
              </tr>
            </tbody></table>
          </div>
          :
          <div/>
        }
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResultEmailByPhone);